module.exports = __webpack_public_path__ + "static/media/p2_18.a38ba8f9.png";